/* Lost & Found 2.0 global.js (F): window.LF */
(() => {
'use strict';
const d = document, root = d.documentElement, LF = (window.LF = window.LF || {});
const json = (id) => { try { const el = d.getElementById(id); return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } };
const define = (n, c) => { if (!customElements.get(n)) customElements.define(n, c); };
const each = (list, fn) => Array.prototype.forEach.call(list, fn);
const rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
const emit = (name, detail) => d.dispatchEvent(new CustomEvent(name, { detail }));

LF.motion = !matchMedia('(prefers-reduced-motion: reduce)').matches;
LF.strings = json('lf-strings');
LF.store = json('lf-store-data');
const t = (LF.t = (key, vars) => {
  let s = LF.strings[key] || '';
  if (vars) Object.keys(vars).forEach((k) => { s = s.split('[' + k + ']').join(vars[k]); });
  return s;
});
LF.money = (c) => '$' + ((Number(c) || 0) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const region = (assertive) => {
  const id = assertive ? 'lf-live-assertive' : 'lf-live-polite';
  let el = d.getElementById(id);
  if (!el) {
    el = d.createElement('div');
    el.id = id; el.className = 'lf-visually-hidden';
    el.setAttribute('aria-live', assertive ? 'assertive' : 'polite');
    el.setAttribute('data-lf-live', '');
    d.body.appendChild(el);
  }
  return el;
};
LF.announce = (msg, o) => { const el = region(o && o.assertive); el.textContent = ''; setTimeout(() => { el.textContent = msg; }, 60); };

const ICON = { success: '<path d="M5 12.5l4.2 4.2L19 7"/>', error: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5v5.5M12 16.2v.3"/>', info: '<circle cx="12" cy="12" r="8.5"/><path d="M12 11v5.5M12 7.8v.3"/>' };
let toastTimer;
LF.toast = (msg, o) => {
  o = o || {};
  const tone = ICON[o.tone] ? o.tone : 'info';
  let el = d.querySelector('[data-lf-toast]');
  if (!el) { el = d.createElement('div'); el.setAttribute('data-lf-toast', ''); el.setAttribute('data-lf-live', ''); el.setAttribute('aria-hidden', 'true'); d.body.appendChild(el); }
  el.className = 'lf-toast lf-toast--' + tone;
  el.innerHTML = '<svg class="lf-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + ICON[tone] + '</svg><span></span>';
  el.lastChild.textContent = msg;
  const hide = () => el.classList.remove('is-visible');
  requestAnimationFrame(() => el.classList.add('is-visible'));
  clearTimeout(toastTimer);
  toastTimer = setTimeout(hide, o.timeout || 4000);
  el.onmouseenter = () => clearTimeout(toastTimer);
  el.onmouseleave = () => { toastTimer = setTimeout(hide, 1500); };
  if (o.announce !== false) LF.announce(msg, { assertive: tone === 'error' });
};

const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),iframe,[tabindex]:not([tabindex="-1"])';
const shown = (el) => !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length) && getComputedStyle(el).visibility !== 'hidden';
const focusables = (el) => Array.prototype.filter.call(el.querySelectorAll(FOCUSABLE), shown);
const KEEP = '[data-lf-live],[id^="shopify-pc"]';
const stack = [];
const inertOutside = (el) => {
  const changed = [];
  const mark = (n) => {
    if (n.inert || /^(SCRIPT|STYLE|LINK|TEMPLATE|NOSCRIPT)$/.test(n.tagName) || n.matches(KEEP)) return;
    if (n.querySelector(KEEP)) { each(n.children, mark); return; }
    n.inert = true; changed.push(n);
  };
  for (let n = el; n && n.parentElement && n !== d.body; n = n.parentElement) each(n.parentElement.children, (s) => { if (s !== n) mark(s); });
  return changed;
};
/* Scroll lock (P18); scrollbar width -> html padding. */
const lock = (on) => {
  const sb = window.innerWidth - root.clientWidth;
  root.style.paddingRight = on && sb > 0 ? sb + 'px' : '';
  root.style.overflow = d.body.style.overflow = on ? 'hidden' : '';
  root.classList.toggle('lf-dialog-open', on);
};
LF.dialog = {
  open(el, o) {
    o = o || {};
    if (!el || stack.some((s) => s.el === el)) return;
    const entry = { el, trigger: o.trigger || d.activeElement };
    el.hidden = false;
    el.setAttribute('aria-modal', 'true');
    entry.inert = inertOutside(el);
    stack.push(entry);
    lock(true);
    const target = o.initialFocus || focusables(el)[0] || el;
    if (target === el && !el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    emit('lf:dialog:open', { el });
  },
  close(el, o) {
    o = o || {};
    const i = stack.findIndex((s) => s.el === el);
    if (i < 0) { if (el) el.hidden = true; return; }
    const entry = stack.splice(i, 1)[0];
    entry.inert.forEach((n) => { n.inert = false; });
    el.hidden = true;
    if (!stack.length) lock(false);
    const back = o.returnFocus === false ? null : o.returnTo || entry.trigger;
    if (back && back.isConnected && back.focus) back.focus({ preventScroll: true });
    emit('lf:dialog:close', { el });
  },
  isOpen: (el) => stack.some((s) => s.el === el)
};
d.addEventListener('keydown', (e) => {
  const top = stack[stack.length - 1];
  if (!top) return;
  if (e.key === 'Escape') { e.preventDefault(); LF.dialog.close(top.el); return; }
  if (e.key !== 'Tab') return;
  const f = focusables(top.el), a = d.activeElement;
  if (!f.length) { e.preventDefault(); return; }
  if (e.shiftKey && (a === f[0] || !top.el.contains(a))) { e.preventDefault(); f[f.length - 1].focus(); }
  else if (!e.shiftKey && (a === f[f.length - 1] || !top.el.contains(a))) { e.preventDefault(); f[0].focus(); }
});

const post = (path, body) => fetch(rootUrl + path, {
  method: 'POST', credentials: 'same-origin',
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
}).then((r) => r.json().catch(() => ({})).then((data) => {
  if (r.ok) return data;
  const err = new Error(data.description || data.message || 'HTTP ' + r.status);
  err.status = r.status; err.data = data;
  throw err;
}));
const countFrom = (sec) => { const m = sec && typeof sec['cart-drawer'] === 'string' && /data-item-count="(\d+)"/.exec(sec['cart-drawer']); return m ? Number(m[1]) : null; };
let drawer = null;
LF.cart = {
  add(o) {
    o = o || {};
    const source = o.source || 'quick-add';
    return post('cart/add.js', { items: [{ id: Number(o.id), quantity: o.quantity || 1 }], sections: 'cart-drawer' })
      .then((data) => { const n = countFrom(data.sections); return (n === null ? LF.cart.refresh() : Promise.resolve(LF.cart.setCount(n))).then(() => data); })
      .then((data) => {
        const detail = { source, item: (data.items && data.items[0]) || data, sections: data.sections || {}, openDrawer: !!o.openDrawer };
        emit('lf:cart:updated', detail);
        if (o.openDrawer && !drawer) location.href = rootUrl + 'cart';
        return detail;
      })
      .catch((err) => { emit('lf:cart:error', { source, status: err.status, message: err.message, title: o.title || '' }); throw err; });
  },
  change(o) {
    o = o || {};
    const body = { quantity: o.quantity, sections: 'cart-drawer' };
    if (o.line) body.line = o.line; else body.id = o.id;
    return post('cart/change.js', body)
      .then((cart) => { LF.cart.setCount(cart.item_count); const detail = { source: 'change', cart, sections: cart.sections || {}, openDrawer: false }; emit('lf:cart:updated', detail); return detail; })
      .catch((err) => { emit('lf:cart:error', { source: 'change', status: err.status, message: err.message }); throw err; });
  },
  refresh() {
    return fetch(rootUrl + 'cart.js', { credentials: 'same-origin' })
      .then((r) => r.json()).then((cart) => { LF.cart.setCount(cart.item_count); return cart; }).catch(() => null);
  },
  setCount(n) {
    const c = Math.max(0, Number(n) || 0);
    each(d.querySelectorAll('[data-cart-count]'), (el) => {
      const prev = Number(el.getAttribute('data-count') || 0);
      el.textContent = String(c);
      el.setAttribute('data-count', String(c));
      if (LF.motion && c > prev) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
    });
    each(d.querySelectorAll('[data-cart-count-text]'), (el) => { el.textContent = c === 1 ? t('cart_items_one') : t('cart_items_other', { count: c }); });
    return c;
  },
  registerDrawer(el) { drawer = el; },
  open(o) { if (drawer && !d.body.classList.contains('template-cart')) { drawer.open(o || {}); return true; } return false; }
};
d.addEventListener('click', (e) => {
  const a = e.target.closest && e.target.closest('a[data-lf-cart-link]');
  if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  if (LF.cart.open({ trigger: a.closest('lf-menu') ? d.getElementById('lf-mobile-toggle') : a })) e.preventDefault();
});

const DAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
/* Store time: Liquid's UTC offset, else Intl. */
const storeNow = (LF.storeNow = () => {
  const m = /^([+-])(\d\d)(\d\d)$/.exec(LF.store.offset || '');
  let n;
  try { n = m ? new Date(Date.now() + ((m[1] + (m[2] * 60 + +m[3])) * 1 + new Date().getTimezoneOffset()) * 6e4) : new Date(new Date().toLocaleString('en-US', { timeZone: LF.store.tz || 'America/Los_Angeles' })); } catch (e) { return null; }
  return isNaN(n) ? null : { day: n.getDay(), mins: n.getHours() * 60 + n.getMinutes() };
});
const toMins = (s) => { const x = String(s).split(':'); return Number(x[0]) * 60 + (Number(x[1]) || 0); };
const fmt = (mins) => {
  let h = Math.floor(mins / 60) % 24;
  const m = mins % 60;
  if (!m && h === 12) return t('noon');
  if (!m && h === 0) return t('midnight');
  const ap = h >= 12 ? t('pm') : t('am');
  h = h % 12 || 12;
  return h + (m ? ':' + String(m).padStart(2, '0') : '') + ' ' + ap;
};
const hoursFor = (day) => { const v = (LF.store.days || {})[DAYS[day]]; return v && v.length === 2 ? [toMins(v[0]), toMins(v[1])] : null; };
LF.storeStatus = () => {
  const s = LF.store, now = storeNow();
  if (!now) return null;
  if (s.override === 'closed_today') return { state: 'closed', text: t('closed_today') };
  if (s.override === 'custom' && s.custom) return { state: 'custom', text: s.custom };
  const h = hoursFor(now.day);
  if (h && now.mins >= h[0] && now.mins < h[1]) return { state: 'open', text: t('open_until', { time: fmt(h[1]) }) };
  if (h && now.mins < h[0]) return { state: 'closed', text: t('opens_today', { time: fmt(h[0]) }) };
  for (let i = 1; i <= 7; i += 1) {
    const dd = (now.day + i) % 7, n = hoursFor(dd);
    if (n) return { state: 'closed', text: i === 1 ? t('opens_tomorrow', { time: fmt(n[0]) }) : t('opens_day', { day: t('day_' + DAYS[dd]), time: fmt(n[0]) }) };
  }
  return { state: 'closed', text: t('closed_today') };
};
LF.todayHours = () => {
  const now = storeNow();
  if (!now) return null;
  const h = LF.store.override === 'closed_today' ? null : hoursFor(now.day);
  return h ? { state: 'open', text: t('today_hours', { open: fmt(h[0]), close: fmt(h[1]) }) } : { state: 'closed', text: t('closed_today') };
};
define('lf-store-status', class extends HTMLElement {
  connectedCallback() { this.render(); }
  render() {
    const st = this.getAttribute('data-mode') === 'today' ? LF.todayHours() : LF.storeStatus();
    const txt = this.querySelector('[data-status-text]');
    if (!st || !txt) return;
    txt.textContent = st.text;
    this.classList.toggle('is-open', st.state === 'open');
  }
});
const markToday = (scope) => {
  const now = storeNow();
  if (!now) return;
  each((scope || d).querySelectorAll('[data-days]'), (row) => {
    const on = row.getAttribute('data-days').split(',').indexOf(DAYS[now.day]) > -1;
    const pill = row.querySelector('.lf-hours__today');
    row.classList.toggle('is-today', on);
    if (!on) { row.removeAttribute('aria-current'); if (pill) pill.remove(); return; }
    row.setAttribute('aria-current', 'date');
    if (pill || row.hasAttribute('data-no-pill')) return;
    const span = d.createElement('span');
    span.className = 'lf-hours__today';
    span.textContent = t('today');
    (row.querySelector('dt') || row).appendChild(span);
  });
};
setInterval(() => { each(d.querySelectorAll('lf-store-status'), (el) => el.render()); markToday(); }, 60000);

define('lf-header', class extends HTMLElement {
  connectedCallback() {
    let ticking = false;
    const update = () => { ticking = false; this.classList.toggle('is-condensed', window.scrollY > 40); };
    this.onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', this.onScroll, { passive: true });
    update();
  }
  disconnectedCallback() { window.removeEventListener('scroll', this.onScroll); }
});

define('lf-menu', class extends HTMLElement {
  connectedCallback() {
    this.toggle = d.querySelector('[aria-controls="' + this.id + '"]');
    this.onToggle = () => this.open();
    this.onClick = (e) => { if (e.target.closest('[data-lf-menu-close]') || e.target.closest('a[href]')) this.close(); };
    this.onClosed = (e) => { if (e.detail.el === this) this.sync(false); };
    if (this.toggle) this.toggle.addEventListener('click', this.onToggle);
    this.addEventListener('click', this.onClick);
    d.addEventListener('lf:dialog:close', this.onClosed);
  }
  disconnectedCallback() {
    if (this.toggle) this.toggle.removeEventListener('click', this.onToggle);
    this.removeEventListener('click', this.onClick);
    d.removeEventListener('lf:dialog:close', this.onClosed);
    if (LF.dialog.isOpen(this)) LF.dialog.close(this, { returnFocus: false });
  }
  open() { this.sync(true); LF.dialog.open(this, { trigger: this.toggle, initialFocus: this.querySelector('.lf-menu__close') }); }
  close(o) { LF.dialog.close(this, o); }
  sync(open) {
    root.classList.toggle('lf-menu-open', open);
    if (this.toggle) this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
});

define('lf-quick-add', class extends HTMLElement {
  connectedCallback() {
    this.btn = this.querySelector('button');
    if (!this.btn || this.bound) return;
    this.bound = true;
    this.btn.addEventListener('click', () => this.add());
  }
  add() {
    const b = this.btn, title = this.getAttribute('data-title') || '', label = b.getAttribute('aria-label');
    if (b.getAttribute('aria-busy') === 'true') return;
    b.setAttribute('aria-busy', 'true');
    b.classList.remove('is-error');
    b.classList.add('is-busy');
    b.setAttribute('aria-label', t('adding'));
    LF.cart.add({ id: this.getAttribute('data-variant-id'), quantity: 1, source: 'quick-add', title })
      .then(() => {
        b.classList.remove('is-busy'); b.classList.add('is-done'); b.setAttribute('aria-label', t('added'));
        LF.toast(t('added_to_cart', { title }), { tone: 'success' });
        setTimeout(() => { b.classList.remove('is-done'); b.setAttribute('aria-label', label); }, 1500);
      })
      .catch((e) => {
        b.classList.remove('is-busy'); b.classList.add('is-error'); b.setAttribute('aria-label', label);
        LF.toast(e && e.status === 422 && e.message || t('add_error', { title }), { tone: 'error' });
        setTimeout(() => b.classList.remove('is-error'), 2500);
      })
      .finally(() => b.removeAttribute('aria-busy'));
  }
});

const fine = matchMedia('(hover: hover) and (pointer: fine)');
define('lf-card-media', class extends HTMLElement {
  connectedCallback() {
    if (this.bound || !this.getAttribute('data-hover-src')) return;
    this.bound = true;
    const card = this.closest('.lf-product-card') || this;
    const inject = (e) => {
      if (e.pointerType !== 'mouse' || !fine.matches) return;
      card.removeEventListener('pointerenter', inject);
      const base = this.querySelector('img'), img = d.createElement('img');
      img.className = 'lf-product-card__img lf-product-card__img--hover';
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      img.decoding = 'async';
      if (base) img.sizes = base.sizes || '';
      if (this.getAttribute('data-hover-srcset')) img.srcset = this.getAttribute('data-hover-srcset');
      img.src = this.getAttribute('data-hover-src');
      this.appendChild(img);
    };
    card.addEventListener('pointerenter', inject);
  }
});

define('lf-back-to-top', class extends HTMLElement {
  connectedCallback() {
    const btn = this.querySelector('button');
    if (!btn || this.bound) return;
    this.bound = true;
    btn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: LF.motion ? 'smooth' : 'auto' });
      const main = d.getElementById('MainContent');
      if (main) main.focus({ preventScroll: true });
    });
    if (!('IntersectionObserver' in window)) { this.hidden = false; return; }
    const s = d.createElement('div');
    s.setAttribute('aria-hidden', 'true');
    s.className = 'lf-btt-sentinel';
    d.body.prepend(s);
    new IntersectionObserver((en) => { this.hidden = en[0].isIntersecting; }).observe(s);
  }
});

const io = LF.motion && 'IntersectionObserver' in window ? new IntersectionObserver((en) => {
  en.forEach((x) => { if (x.isIntersecting) { x.target.classList.add('is-revealed'); io.unobserve(x.target); } });
}, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
const reveal = (LF.reveal = (scope) => {
  const els = (scope || d).querySelectorAll('[data-reveal]:not(.is-revealed)');
  if (!io) { each(els, (el) => el.classList.add('is-revealed')); return; }
  root.classList.add('lf-reveal-ready');
  each(els, (el) => io.observe(el));
});

const init = () => {
  reveal();
  markToday();
  (window.requestIdleCallback || ((fn) => setTimeout(fn, 1200)))(() => {
    const badge = d.querySelector('[data-cart-count]');
    if (/(^|;\s*)cart=/.test(d.cookie) || (badge && Number(badge.getAttribute('data-count')) > 0)) LF.cart.refresh();
  });
};
if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
d.addEventListener('shopify:section:load', (e) => { reveal(e.target); markToday(e.target); });
})();
